export default "__VITE_ASSET__C857mfMn__"